import React, { Fragment, useState } from "react";
import { read } from "Helpers/LocalStorage";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

export default function Training() {
  const username = read("userId");
  const [loading, setLoading] = useState(true);
  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <MuiPaper className="mt-3">
        <iframe
          src={`https://fdpco.ir/request-training-webwin/?username=${username}`}
          title="Training"
          onLoad={() => setLoading(false)}
          style={{
            width: "100%",
            height: "700px",
            border: "none",
          }}
        />
      </MuiPaper>
    </Fragment>
  );
}
